import Alpine from "alpinejs"
import { cmToFtIn, ftInToCm } from "../dataStore"

export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  formValues: {
    heightCm: null,
    heightFt: null,
    heightIn: null,
    targetWeightKg: null,
    targetWeightLbs: null,
  },

  skipValidationsFor: ["targetWeightKg", "targetWeightLbs"],

  onInit() {
    Alpine.effect(() => {
      if (this.store.isMetric) {
        const imperialHeight = cmToFtIn(this.formValues.heightCm)

        this.formValues.heightFt = imperialHeight.heightFt || 0
        this.formValues.heightIn = imperialHeight.heightIn || 0
      } else {
        this.formValues.heightCm =
          ftInToCm({
            ft: this.formValues.heightFt,
            inch: this.formValues.heightIn,
          }) || 0
      }
    })

    Alpine.effect(() => {
      if (this.formValues.heightCm || this.formValues.heightFt || this.formValues.heightIn) {
        this.formValues.targetWeightKg = null
        this.formValues.targetWeightLbs = null
      }
    })
  },

  processFormValues() {
    if (this.store.isMetric) {
      const imperialHeight = cmToFtIn(this.formValues.heightCm)

      return {
        heightCm: parseInt(this.formValues.heightCm),
        heightFt: imperialHeight.heightFt,
        heightIn: imperialHeight.heightIn,
        targetWeightKg: this.formValues.targetWeightKg,
        targetWeightLbs: this.formValues.targetWeightLbs,
      }
    } else {
      return {
        heightCm: ftInToCm({ ft: this.formValues.heightFt, inch: this.formValues.heightIn }),
        heightFt: parseInt(this.formValues.heightFt),
        heightIn: parseInt(this.formValues.heightIn),
        targetWeightKg: this.formValues.targetWeightKg,
        targetWeightLbs: this.formValues.targetWeightLbs,
      }
    }
  },
})
